// Shared helpers for the jewelry reports' Vendor(s)/Retailer(s) multi-select
// filters and the detail table's sort-column mapping (antd's camelCase
// dataIndex -> the backend's PascalCase sortColumnName).

// The Vendor/Retailer <Select> options are keyed "dealerID|dealerCompany" so
// the label survives round-tripping through antd's multi-select value array;
// this strips it back down to a plain id (or "0" for the synthetic "All").
export const extractDealerId = (value) => {
  if (value === 0 || value === "0") return "0";
  if (typeof value === "string" && value.includes("|")) {
    return value.split("|")[0];
  }
  return value.toString();
};

export const extractDealerIds = (values) => {
  if (!values || values.length === 0) return [];
  return values.map(extractDealerId);
};

const SORT_COLUMN_MAP = {
  userIPAddress: "UserIPAddress",
  vendorName: "VendorName",
  retailerName: "RetailerName",
  collectionNew: "CollectionNew",
  category: "Category",
  date: "Date",
  styleNumber: "StyleNumber",
  metalType: "MetalType",
  metalColor: "MetalColor",
  price: "Price",
};

export const mapSortColumn = (dataIndex) => SORT_COLUMN_MAP[dataIndex] || "Date";
